import { ajax, file as fileUtil } from "@utils";
import { saveAs } from "file-saver";

export const fileService = {
  /**
   * 下載檔案
   * @key DownloadAttachmentByProperty
   * @param {string} fiileId - 檔案 id
   * @returns
   */
  async download(fileId) {
    const response = await ajax.get(
      `${process.env.REACT_APP_API_URL}/property/attachments/${fileId}/download`
    );

    const fileName = fileUtil.getFileNameByResponse(response, true);
    const blob = await response.blob();

    saveAs(blob, fileName);
  }
};
